import React from "react";
import DividerBlock from "../../../divider-block";
import { DatePicker } from "antd";
import { Col, Row } from "antd";
import { Button, Checkbox } from "antd";
import InputField from "../../../input-field";
import { uuidHelper } from "../../../../helpers/uuid.helper";
import TextArea from "antd/lib/input/TextArea";
import SelectField from "../../../select-field";
import { useEffect, useState } from "react";
import { notification } from "antd";
import { systemService } from "../../../../services";
import i18n from "../../../../i18n";

const { RangePicker } = DatePicker;

export function Cost() {
  this.uuid = uuidHelper.generateUUID();
  this.name = '';
  this.required = true;
  this.currencyId = 1;
}

export default function Multicost({
  costs,
  setCosts,
  costComment,
  setCostComment,
  fieldsErrors,
  dividerStyle,
  isMultimodal}
) {

  const [currencyTypesList, setCurrencyTypesList] = useState([]);
  const [taxTypes, setTaxTypes] = useState([]);
  const [taxTypesLoaded, setTaxTypesLoaded] = useState(false);

  useEffect(() => {
    systemService
        .getCurrencyList()
        .then(resp => {
            setCurrencyTypesList(resp)
        })
        .catch(err => {
            notification.error({
                message: "Получение списка валют",
                description: err
            });
        });
  }, []);

  useEffect(() => {
    if (!taxTypesLoaded) {
      systemService.getMultimodalTaxTypes()
        .then(res => {
          setTaxTypesLoaded(true);
          setTaxTypes(res);
        })
        .catch(errMsg => {
          setTaxTypesLoaded(true);
          notification.error(
            {
              message: i18n.t('components.notification.titles.getTaxTypes'),
              description: errMsg
            });
        });
    }
  }, []);

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: 'transparent', boxShadow: 'none' };

  const getCostErrors = (nameField, key) => {
    return (fieldsErrors && typeof fieldsErrors['cost.'+key+'.'+nameField] !== "undefined")
      ? fieldsErrors['cost.'+key+'.'+nameField][0]
      : null;
  };

  const addCost = () => {
    if (costs.length < 10) {
        const newCosts = [...costs];
        newCosts.push(new Cost());
        setCosts(newCosts);
    }
};

  const renderCosts = (costs, setCosts) => {
    const removeCost = (uuid) => {
      costs.forEach((e, i) => {
          if (i > 0) {
              if (e.uuid === uuid) {
                  const newCosts = [...costs];
                  newCosts.splice(i, 1);
                  setCosts(newCosts);
              }
          }
      })
    };

    const updateCost = (key, value, uuid) => {
      const newCosts = [...costs];
      newCosts.forEach((e, i) => {
          if (e.uuid === uuid) {
            newCosts[i][key] = value;
            setCosts(newCosts);
          }
      });
    };

    return costs.map((cost, i) => (
      <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', marginTop: '10px', padding: '15px' }} key={`cost-${i}`}>
        <Row gutter={[16, 24]} key={i + 1} >
          <Col lg={isMultimodal ? 8 : 16} md={24} sm={24} sx={24}>
              <InputField
                  name="name" label={i18n.t('consignorPage.createDelivery.content.name')}
                  value={cost.name} setValue={value => updateCost('name', value, cost.uuid)}
                  keyNum={cost.uuid}
                  getFieldErrors={getCostErrors}
              />
          </Col>
          {isMultimodal && <>
            <Col lg={cost.currencyId === 1 ? 4: 8} md={24} sm={24} sx={24}>
                <SelectField
                  title="Валюта"
                  name="currencyId"
                  selectedValue={cost.currencyId}
                  values={currencyTypesList}
                  keyNum={cost.uuid}
                  onChange={(value) => {
                      updateCost('currencyId', value, cost.uuid);
                      if(value !== 1) {
                        updateCost('taxType', '', cost.uuid);
                      }
                  }}
                  getErrors={getCostErrors}
                  placeholder="Выберите валюту"
                  style={{ width: "100%" }}
                />
            </Col>
            {(cost.currencyId === 1) && <Col lg={4} md={24} sm={24} sx={24}>
              <SelectField
                title={i18n.t('deliveries.content.tax')}
                name="taxType"
                selectedValue={cost.taxType}
                values={taxTypes}
                keyNum={cost.uuid}
                getErrors={getCostErrors}
                allowClear={true}
                onChange={(value) => {
                    updateCost('taxType', value, cost.uuid);
                }}
                placeholder='-'
                style={{width: "100%"}}
              />
            </Col>}
          </>}
          <Col lg={4} md={24} sm={24} sx={24}>
            <Checkbox
                name="required"
                checked={cost.required}
                onChange={(e) => {
                    updateCost('required', e.target.checked, cost.uuid);
                }}
                style={{fontSize: "10pt", paddingTop: "28px"}}
            >
              {i18n.t('consignorPage.createDelivery.content.required')}
            </Checkbox>
          </Col>
          <Col lg={4} md={24} sm={24} sx={24}>
            <Button
                type="danger"
                icon="close"
                onClick={() => removeCost(cost.uuid)}
                style={{ ...bigButtonStyle, backgroundColor: 'red', color: 'white', float: 'right', width: '50px' }}
            />
          </Col>
        </Row>
      </div >
    ));
  }

    return (
      <>
      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.priceParts')}</span>
      <Row gutter={[16, 24]}>
        <Col lg={24} md={24} sm={24} sx={24}>
          <TextArea
            placeholder={i18n.t('consignorPage.createDelivery.content.costComment')}
            value={costComment}
            onChange={(e) => {
              setCostComment(e.target.value)
            }}
            autoSize={{ minRows: 2, maxRows: 8 }}
          />
        </Col>
      </Row>
      {renderCosts(costs, setCosts)}
      <Row gutter={[16, 24]} style={{ marginBottom: '60px' }}>
          <Col lg={24} md={24} sm={24} sx={24} style={{ textAlign: 'center' }}>
              <Button type="primary" size="small" htmlType="button" onClick={addCost} style={{ ...bigButtonStyle }}>{i18n.t('main.buttons.add')}</Button>
          </Col>
      </Row>
      <DividerBlock style={dividerStyle} />
      </>
    );
}
